import React from "react";
import { useHistory } from "react-router-dom";

// hooks and utilities
import { useLanguage } from "lang/Translate";

// css
import "./scss/Errors.scoped.scss";

const Errors = ({ errors }) => {
    const currLanguage = useLanguage();
    const history = useHistory();

    function onResetPassword() {
        history.push("/verification?type=resetPassword");
    }

    if (errors.length <= 0) return <></>;
    return (
        <div className="errors">
            {errors.map((e, i) => (
                <div className="error" key={i}>
                    {currLanguage === "PL" ? e.error : e.errorEn || e.error}!
                    {e.errorEn === "Invalid e-mail or password" && (
                        <div className="reset" onClick={onResetPassword}>
                            {currLanguage === "PL"
                                ? "Nie pamiętasz hasła? Kliknij by zresetować"
                                : "Forgot your password? Click to reset"}
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default Errors;
